import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Container, TAGAccordions, TAGTypography, Grid, useMediaQuery } from '../..';
import * as templates from '.';

var Accordions = function Accordions(_ref) {
  var accordions = _ref.accordions,
      branding = _ref.branding,
      _ref$centerAlign = _ref.centerAlign,
      centerAlign = _ref$centerAlign === void 0 ? false : _ref$centerAlign,
      description = _ref.description,
      title = _ref.title;
  var mobileWidth = useMediaQuery('(max-width:600px)');

  var _accordions$reduce = accordions.reduce(function (couple, accordion, index) {
    var _accordion$branding;

    couple[0].push(accordion.title);
    couple[1].push(accordion.__typename && templates[accordion.__typename.slice(10)] && React.createElement(templates[accordion.__typename.slice(10)], _objectSpread(_objectSpread({}, accordion), {}, {
      branding: (_accordion$branding = accordion.branding) !== null && _accordion$branding !== void 0 ? _accordion$branding : branding,
      key: "".concat(accordion.contentful_id, "-accordionContent").concat(index)
    })));
    return couple;
  }, [[], []]),
      _accordions$reduce2 = _slicedToArray(_accordions$reduce, 2),
      titles = _accordions$reduce2[0],
      children = _accordions$reduce2[1];

  return React.createElement(Container, null, (title || description) && React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: centerAlign ? 'center' : 'flex-start',
    spacing: 2,
    sx: {
      paddingLeft: '10px',
      marginBottom: '10px'
    }
  }, title && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "h2",
    color: "primary"
  }, title)), description && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: mobileWidth ? 'bodyMediumBook' : 'bodyLargeBook',
    color: "text.secondary"
  }, description))), React.createElement(TAGAccordions, {
    boxBgColorDark: false,
    button: false,
    titles: titles
  }, children));
};

export default Accordions;